import { ViewService } from '../../models'

export const DEFAULT_SERVICE: Omit<ViewService, 'id'> = {
  active: false,
  name: 'Neue Dienstleistung',
  order: 0,
  description: '',
  onlineAvailable: false,
  price: 0,
  duration: 0,
  buffer: 0,
  categories: [],
}
